// src/pages/admin/VendorManagement/index.tsx

import React, { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

const VendorManagement: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    
    const tabs = [
        { id: 'vendors', label: 'All Vendors', path: '/dashboard/vendors' },
        { id: 'applications', label: 'Applications', path: '/dashboard/vendors/applications' },
        { id: 'type-changes', label: 'Type Changes', path: '/dashboard/vendors/type-changes' },
    ];

    const activeTab = tabs.find(tab => location.pathname === tab.path)?.id || 'vendors';

    return (
        <div className="space-y-6">
            {/* Header */}
            <div>
                <h1 className="text-2xl font-bold text-gray-900">Vendor Management</h1>
                <p className="text-sm text-gray-500">Manage vendors, applications, and type change requests</p>
            </div>

            {/* Tabs */}
            <div className="border-b border-gray-200">
                <nav className="flex gap-6">
                    {tabs.map((tab) => (
                        <button
                            key={tab.id}
                            onClick={() => navigate(tab.path)}
                            className={`p-3 ph-2 px-1 text-sm font-medium border-b-2 transition-colors ${
                                activeTab === tab.id
                                    ? 'border-blue-600 text-blue-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700'
                            }`}
                        >
                            {tab.label}
                        </button>
                    ))}
                </nav>
            </div>

            {/* Content */}
            <div>
                <Outlet />
            </div>
        </div>
    );
};

export default VendorManagement;